import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad, Sparkles, Mail, Phone, MessageSquare } from 'lucide-react';

const Home = () => {
  return (
    <div className="h-screen snap-y snap-mandatory overflow-y-scroll bg-white w-full">
      {/* Hero Section */}
      <section className="h-screen w-full snap-start relative overflow-hidden flex items-center">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-100 via-blue-50 to-white"></div>
        <div className="w-full relative z-10">
          <div className="flex items-center justify-center h-full">
            <div className="max-w-3xl">
              <div className="flex items-center gap-4 mb-6 justify-center">
                <Gamepad className="w-12 h-12 text-purple-600 animate-bounce" />
                <h2 className="text-6xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Welcome to Cloud Gaming
                </h2>
              </div>
              <p className="text-2xl mb-8 text-gray-700 text-center">
                Play your favorite games instantly, anywhere, anytime.
                <Sparkles className="inline ml-2 w-6 h-6 text-yellow-500 animate-pulse" />
              </p>
              <div className="text-center">
                <Link to="/" 
                  className="inline-block bg-gradient-to-r from-purple-500 to-pink-500 px-8 py-4 rounded-lg text-xl font-bold text-white
                  transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-purple-500/50">
                  Start Gaming Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="h-screen w-full snap-start relative overflow-hidden flex items-center">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-purple-50 to-white"></div>
        <div className="w-full relative z-10">
          <div className="flex items-center justify-center h-full">
            <div className="max-w-4xl">
              <h2 className="text-5xl font-bold mb-12 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent text-center">
                Level Up Your Gaming Experience
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border border-purple-100">
                  <h3 className="text-2xl font-bold mb-4 text-purple-600">Who We Are</h3>
                  <p className="text-lg text-gray-600">
                    A team of passionate game developers dedicated to creating innovative and immersive gaming experiences.
                  </p>
                </div>
                <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border border-purple-100">
                  <h3 className="text-2xl font-bold mb-4 text-purple-600">Our Mission</h3>
                  <p className="text-lg text-gray-600">
                    Pushing the boundaries of interactive entertainment to deliver unique experiences that captivate and inspire.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="h-screen w-full snap-start relative overflow-hidden flex items-center">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-purple-50 to-white"></div>
        <div className="w-full relative z-10">
          <div className="flex items-center justify-center h-full">
            <div className="max-w-4xl w-full">
              <h2 className="text-5xl font-bold mb-12 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent text-center">
                Join Our Gaming Community
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                <div className="bg-white p-6 rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border border-purple-100">
                  <Mail className="w-8 h-8 text-purple-600 mb-4" />
                  <h3 className="text-xl font-bold mb-2 text-purple-600">Email Us</h3>
                  <p className="text-gray-600">contact@strayapps.org</p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border border-purple-100">
                  <Phone className="w-8 h-8 text-purple-600 mb-4" />
                  <h3 className="text-xl font-bold mb-2 text-purple-600">Call Us</h3>
                  <p className="text-gray-600">1-800-STRAY-GAMES</p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 border border-purple-100">
                  <MessageSquare className="w-8 h-8 text-purple-600 mb-4" />
                  <h3 className="text-xl font-bold mb-2 text-purple-600">Follow us</h3>
                  <p className="text-gray-600">Discord</p>
                </div>
              </div>
              
              <div className="text-center mt-8">
                <Link 
                  to="/terms" 
                  className="text-sm text-gray-500 hover:text-purple-600 transition-colors"
                >
                  Terms and Conditions
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;